(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const domEstrutura = document.querySelector(".estrutura");

    if (!domEstrutura) {
      return;
    }

    domEstrutura.querySelectorAll(".acfgallery-item").forEach((_domItem) => {
      const __domBtnAbrirImagem = _domItem.querySelector(
        ".wrap-item-acfgallery a"
      );
      const __domDescription = _domItem.querySelector(
        "figcaption .description"
      );

      window.requestAnimationFrame(() => {
        __domBtnAbrirImagem.appendChild(__domDescription);
      });
    });
  });
})();
